import { useContext } from 'react';
import { PipeProviderContext } from './index';

const usePipeContext = () => useContext(PipeProviderContext);
export default usePipeContext;
